import React from 'react'
import VBTeamStats from '../components/VBTeamStats'

const TeamStats = ({ match }) => {
  return <VBTeamStats isPublic='true' vbTeamId={match.params.id} />
}

export default TeamStats
